import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StyledAppSideNav } from './AppSideNav.styles';
import {
  selectHasAccessToGCD,
  selectHasAccessToRobots,
} from 'app/cross-cutting-concerns/authentication/state/authenticationSelectors';
import { RoutePaths } from 'config/route-paths';

interface AppSideNavProps {
  collapsed: boolean;
}

const getNavItemClassName = ({ isActive }: { isActive: boolean }): string =>
  isActive ? 'app-side-nav__item active' : 'app-side-nav__item';

export const AppSideNav = ({ collapsed }: AppSideNavProps): JSX.Element => {
  const { t } = useTranslation();
  const haveRobots = useSelector(selectHasAccessToRobots);
  const haveGCD = useSelector(selectHasAccessToGCD);

  const showMachineDashboard = !haveRobots || haveGCD;
  const showRobotDashboard = haveRobots;

  return (
    <StyledAppSideNav className={collapsed ? 'app-side-nav--collapsed' : ''}>
      <div className="app-side-nav__inner">
        <section className="app-side-nav__section">
          <div className="app-side-nav__section-title">{t('navigation.fleetOperations')}</div>
          {showMachineDashboard && (
            <NavLink to={RoutePaths.MACHINE_DASHBOARD} className={getNavItemClassName}>
              {t('common.machineDashboard')}
            </NavLink>
          )}
          {showRobotDashboard && (
            <NavLink to={RoutePaths.ROBOT_DASHBOARD} className={getNavItemClassName}>
              {t('common.robotDashboard')}
            </NavLink>
          )}
          <NavLink to={RoutePaths.MACHINES} className={getNavItemClassName}>
            {t('common.devices')}
          </NavLink>
          <NavLink to={RoutePaths.EVENTS} className={getNavItemClassName}>
            {t('common.reports')}
          </NavLink>
          <NavLink to={RoutePaths.NOTIFICATIONS} className={getNavItemClassName}>
            {t('common.notifications')}
          </NavLink>
        </section>

        <div className="app-side-nav__divider" />

        <section className="app-side-nav__section">
          <div className="app-side-nav__section-title">{t('navigation.infrastructure')}</div>
          <NavLink to={RoutePaths.SITES} className={getNavItemClassName}>
            {t('common.sites')}
          </NavLink>
        </section>

        <div className="app-side-nav__divider" />

        <section className="app-side-nav__section">
          <div className="app-side-nav__section-title">{t('navigation.administration')}</div>
          <NavLink to={RoutePaths.USERS} className={getNavItemClassName}>
            {t('common.userManagement')}
          </NavLink>
        </section>
      </div>
    </StyledAppSideNav>
  );
};
